import { forEach as _forEach } from "lodash";

export const methodSwitcher = (state, data, id = -1, method, param = {}) => {
  if (!state.list.rows) return {};
  const getIdxFromId = (_id) => state.list.rows.findIndex((x) => x.id === _id);

  let idx = -1;
  switch (method) {
    case "add":
      if (Array.isArray(data)) state.list.rows = data.concat(state.list.rows);
      else state.list.rows.push(data);
      break;
    case "remove":
      idx = getIdxFromId(id);
      if (idx !== -1) state.list.rows.splice(idx, 1);
      break;
    case "replace":
      idx = getIdxFromId(id);
      if (idx !== -1) state.list.rows.splice(idx, 1, data);
      break;
    case "modify":
      idx = getIdxFromId(id);
      if (idx !== -1) {
        const target = state.list.rows[idx];
        _forEach(param, function (v, k) {
          if (Object.prototype.hasOwnProperty.call(target, k)) {
            target[k] = v;
          }
        });
      }
      break;
    default:
  }
  return state;
};

export const createReducer = (initialState, handlers) => {
  return (state = initialState, action) => {
    if (Object.prototype.hasOwnProperty.call(handlers, action.type)) {
      return handlers[action.type](state, action);
    } else {
      return state;
    }
  };
};
